import React, {Component, Fragment} from "react";
import axios from "axios";
import {ContentState, convertToRaw, EditorState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faPen, faTrash, faXmark,faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import {Badge, Form, ListGroup} from "react-bootstrap";
import draftToHtml from "draftjs-to-html";
import {accountService} from "./Account.service";
import Moment from "moment/moment";
import Accordion from 'react-bootstrap/Accordion';


accountService.isLoggedRedirect();
class CareersAdmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            careersdatas: [],
            modalcareer: false,
            careereditdatas: [],
            wysi : null,
            media: [],
            rubriclist : ["id", "société", "titre du poste", "actions"],
            activeKey : null,
            dateend: null,
            datestart: null,
            idcv: []
        }
    }
    mytoken = JSON.parse(localStorage.getItem('token')).token;
    config = {
        headers: { Authorization: `Bearer ${this.mytoken}` }
    };

    setNewCareer(rootpath){
        window.location.replace(rootpath);
    }

    getCvId = () => {
        axios.get(process.env.REACT_APP_API_URLSF+`/api/cvids`, this.config)
        .then(data => {
                this.setState({idcv : data.data});
            }
        ).catch(err => console.error(err));
    }

    getCvOwner(){
        axios.get(process.env.REACT_APP_API_URLSF+`/api/cvowner`, this.config)
            .then(data => {
                    this.setState({cvowner : data.data});
                }
            ).catch(err => console.error(err));
    }

    getcareers(){
        axios.get(process.env.REACT_APP_API_URLSF+`/api/careers`,this.config )
            .then(res => {
                this.setState({careersdatas : res.data });
            })
            .catch(err => console.error(err));
    }
    deletecareer(id){
        axios.delete(process.env.REACT_APP_API_URLSF+`/api/career/`+id, this.config)
            .then(res => {
                this.getcareers();
                console.log('élément supprimé'+res);
            })
            .catch(err => console.error(err));
    }
    formatDate(date){
        const [annee, mois, jour] = date.substring(0, 10).split('-');
        return `${annee}-${mois}-${jour}`
    }
    convertBoolToInt(val){
        return val ? 1 : 0;
    }
    editcareer(id){
        this.setState({modalcareer : true })
        axios.get(process.env.REACT_APP_API_URLSF+`/api/career/`+id, this.config)
            .then(res => {
                this.setState({careereditdatas : res.data})
                this.setState({datestart: this.formatDate(res.data.datestart) })
                this.setState({dateend: this.formatDate(res.data.dateend)})
                const contentBlock = htmlToDraft(res.data.taskdescription);
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                const editorState = EditorState.createWithContent(contentState);
                this.setState({editorState : editorState });
            })
            .catch(err => console.error(err));
    }
    handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if(name === 'dateend' || name === 'datestart'){
            this.setState({careereditdatas : {[name]: value+'T15:52:01+00:00'} })
        }else{
            this.setState({careereditdatas : {[name]: value} })
        }
        console.log(value);
    };
    handleClose() {
        this.setState({modalcareer : false })
    };
    componentDidMount() {
        this.getcareers();
        this.getCvId();
        const html = '<p>Add a descrition <strong>Here</strong>😀</p>';
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({editorState})
        }
    }
    onEditorStateChange: Function = (editorState) => {
        this.setState({
            editorState,
        });
        this.setState({wysi : draftToHtml(convertToRaw(editorState.getCurrentContent())) })
    };
    deleteImg(id){
         axios.delete(process.env.REACT_APP_API_URLSF+`/api/media/`+id, this.config)
             .then(res => {
                 this.setState((prevState) => ({
                     media: prevState.media.filter(val => val.id !== id)
                 }));
                 console.log('élément supprimé'+res);
             })
             .catch(err => console.error(err));
    }

    isCvId = (careereditdatas, careerid) => {
          let careeriddatas =  careereditdatas.curriculum !== undefined ? careereditdatas.curriculum.id : 0;
          let response;
              response = (careeriddatas === careerid) && (careerid !== null);
              return response;
    }
    getMediaByCareer = (id) => {
        axios.get(process.env.REACT_APP_API_URLSF+`/api/media/`+id,this.config )
            .then(res => {
                this.setState({media : res.data });
            })
            .catch(err => console.error(err));
    };

    handleFileChange = (event) => {
        const { files } = event.target;
        this.setState({ files });
    };
    handleSubmit = (e) => {
        e.preventDefault();
        axios.post(process.env.REACT_APP_API_URLSF+`/api/media`, e.target, this.config)
            .then(data => {

                    axios.get(process.env.REACT_APP_API_URLSF+`/api/media/`+data.data.idcareer,this.config )
                        .then(res => {
                            this.setState({media : res.data });
                        })
                        .catch(err => console.error(err));
            }

            ).catch(err => console.error(err))
    };
    handleEdit = (e) => {
        e.preventDefault();
        let career = e.target.elements.careerid[0].value;

      /**
        const { editorState } = this.state;
        const contenu = editorState.getCurrentContent().getPlainText(); // Obtenir le texte brut
        console.log('Contenu soumis:', contenu);

         let datas = [
             {jobtitle:           e.target.elements.jobtitle.value},
             {taskdescription :    contenu},
             {datestart:          e.target.elements.datestart.value + 'T15:52:01+00:00'},
             {dateend:            e.target.elements.dateend.value + 'T15:52:01+00:00'},
             {society:            e.target.elements.society.value},
             {societyaddress:         e.target.elements.societyaddress.value},
             {link:               e.target.elements.link.value},
             {inplace:            e.target.elements.inplace.value},
             //  active: this.state.check,
         ];
          this.setState({careereditdatas : datas });
*/
        this.state.careereditdatas = {
            mycvid : e.target.elements.mycvid.value,
            jobtitle : e.target.elements.jobtitle.value,
            taskdescription: this.state.wysi,
            society : e.target.elements.society.value,
            societyaddress : e.target.elements.societyaddress.value,
            datestart : e.target.elements.datestart.value+'T15:52:01+00:00',
            dateend : e.target.elements.dateend.value+'T15:52:01+00:00',
            link : e.target.elements.link.value,
          inplace : e.target.elements.inplace.checked
        }
        const dataEncodedtoJson = JSON.stringify(this.state.careereditdatas);

        axios.put(process.env.REACT_APP_API_URLSF+`/api/career/`+career, dataEncodedtoJson, this.config)
            .then(res => {
                this.handleClose()
                console.log(res)
                res.status === 204 ?  this.getcareers() : console.log(res.status);
            })
            .catch(err => console.error(err));
    }
    render() {
        const {careersdatas} = this.state !== undefined ? this.state : '';
        const { editorState } = this.state !== undefined ? this.state : '';
        const { careereditdatas } = this.state !== undefined ? this.state : '';
        const { datestart } = this.state !== undefined ? this.state : '';
        const { dateend } = this.state !== undefined ? this.state : '';
        const { rubriclist } = this.state !== undefined ? this.state : '';
        const { media } = this.state !== undefined ? this.state : '';
        const { idcv } = this.state !== undefined ? this.state : '';

        return(
            <Fragment>
                <section id="signup" className="signup-section">
                    <div className="container">
                        <h2>Gestion des carrières</h2>
                        <div className="align-self-center">
                            <Button variant="warning" onClick={() => this.setNewCareer('/admin/career/add')}>
                                <FontAwesomeIcon icon={faPen} />
                            </Button>
                            <hr/>
                            <Table striped bordered hover>
                                <thead>
                                <tr>
                                    {rubriclist.map((val) => (
                                        <th key={val}>{val}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {careersdatas.map(info => (
                                    <tr>
                                        <th>{info.id}</th>
                                        <th>{info.society}</th>
                                        <th>
                                            {info.jobtitle}
                                            {info.inplace}{info.inplace ? (
                                            <Badge  key={info.id} pill bg="success"> <FontAwesomeIcon icon={faEye}/></Badge>
                                        ) : (
                                            <Badge  key={info.id} pill bg="danger"><FontAwesomeIcon icon={faEyeSlash}/></Badge>
                                        )}
                                        </th>
                                        <th>
                                            <ButtonGroup aria-label="Basic example">
                                                <Button variant="success">
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Button>
                                                <Button variant="warning" onClick={() => this.editcareer(info.id)}>
                                                    <FontAwesomeIcon icon={faPen}/>
                                                </Button>
                                                <Button variant="danger" onClick={() => this.deletecareer(info.id)}>
                                                    <FontAwesomeIcon icon={faXmark} />
                                                </Button>
                                            </ButtonGroup>
                                        </th>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>

                            <Modal show={this.state.modalcareer}  onHide={() => this.handleClose()}>

                                <Modal.Header closeButton  onClick={() => this.handleClose()}>
                                </Modal.Header>
                                <Modal.Body>
                                    <Accordion defaultActiveKey={this.state.activeKey}>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header  onClick={() => this.getMediaByCareer(careereditdatas.id)}>gestion des images</Accordion.Header>
                                            <Accordion.Body>
                                                <ListGroup>
                                                    {media.map( (val,index) => (
                                                        <ListGroup.Item variant="primary" id={val.id}>
                                                            <strong key={index}>{val.name}</strong>
                                                            <Button variant="warning" onClick={() => this.deleteImg(val.id)}>
                                                                <FontAwesomeIcon className="small" icon={faTrash} />
                                                            </Button>
                                                        </ListGroup.Item>
                                                    ) )}
                                                </ListGroup>
                                                <Form onSubmit={this.handleSubmit.bind(this)}>
                                                    <Form.Group controlId="formFileMultiple" className="mb-3">
                                                        <Form.Label>Multiple files input example</Form.Label>
                                                        <Form.Control type="file" name="imageFile[]" multiple  onChange={this.handleFileChange}/>
                                                        <Form.Control type="text"  name="careerid" hidden="true" value={careereditdatas.id} />
                                                        <Form.Control type="text" name="imagetype" value="career" hidden="true" />
                                                        <button type="submit">Envoyer</button>
                                                    </Form.Group>
                                                </Form>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <Form onSubmit={this.handleEdit.bind(this)}>
                                        <Form.Control type="text" name="careerid" value={careereditdatas.id} hidden={true}/>
                                        <Modal.Title  className="mb-3" >Modifier la carrière n° {careereditdatas.id}</Modal.Title>
                                        <Form.Control type="text" name="careerid" hidden="true"/>
                                        <Form.Group className="mb-3">
                                            <Form.Text className="text-muted">
                                                Curriculum
                                            </Form.Text>
                                        <Form.Select name="mycvid" key={careereditdatas.id} onChange={this.handleChange} required="true">
                                                    <option value="empty" disabled selected={true}>Sélectionnez un curriculum</option>
                                                        {idcv.map((item) => {
                                                            return (
                                                                <option value={item.id} selected={this.isCvId(careereditdatas,item.id)}>{item.id}</option>
                                                            )
                                                        })
                                                        }
                                        </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Group className="mb-3">
                                                <Form.Control type="text" name="jobtitle" value={careereditdatas.jobtitle} onChange={this.handleChange}/>
                                                <Form.Text className="text-muted">
                                                    Titre du poste.
                                                </Form.Text>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Control type="text" placeholder={careereditdatas.society} name="society" value={careereditdatas.society} onChange={this.handleChange}/>
                                                <Form.Text className="text-muted">Société</Form.Text>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Control type="text" placeholder={careereditdatas.societyaddress} name="societyaddress" value={careereditdatas.societyaddress} onChange={this.handleChange}/>
                                                <Form.Text className="text-muted">Adresse société</Form.Text>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                            <Form.Control size="sm" type="date" defaultValue={datestart} name="datestart" onChange={this.handleChange}/>
                                                <Form.Text className="text-muted">
                                                    Date de début  : {Moment(careereditdatas.datestart).format("DD/MM/YYYY")}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Control size="sm" type="date" defaultValue={dateend} name="dateend" onChange={this.handleChange}/>
                                                <Form.Text className="text-muted">
                                                    Date de fin : {Moment(careereditdatas.dateend).format("DD/MM/YYYY")}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Label>Description des taches</Form.Label>
                                            <Editor
                                                editorState={editorState}
                                                name="taskdescription"
                                                wrapperClassName="demo-wrapper"
                                                editorClassName="demo-editor"
                                                onEditorStateChange={this.onEditorStateChange}
                                                toolbar={{
                                                    colorPicker: {
                                                        className: undefined,
                                                        component: undefined,
                                                        popupClassName: undefined,
                                                        colors:
                                                            ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                                                                'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                                                                'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                                                                'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                                                                'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                                                                'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                                                        image: {
                                                            defaultSize: {
                                                                height: 'auto',
                                                                width: '100%',
                                                            },
                                                        },
                                                    },
                                                }}
                                            />
                                             <Form.Group className="mb-3">
                                                 <Form.Control type="link" placeholder={careereditdatas.link} name="link" value={careereditdatas.link} onChange={this.handleChange}/>
                                                 <Form.Text className="text-muted">Site web</Form.Text>
                                             </Form.Group>
                                             <Form.Group className="mb-3">
                                                 <Form.Text className="text-muted">Ceci est mon poste actuel ?{careereditdatas.inplace}</Form.Text>
                                                 <Form.Check type="checkbox"
                                                             id={careereditdatas.id}
                                                             name="inplace"
                                                             defaultChecked={careereditdatas.inplace}
                                                             onChange={this.handleChange}/>
                                             </Form.Group>
                                            <input type="submit" value="Submit" className="btn btn-danger"/>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}

export default CareersAdmin;